<template>
  <div>
    <div class="mail-box-header">
      <form class="row" @submit.prevent="listConsumers">
        <div class="col-lg-6">
          <div class="input-group col-lg-12">
            <input
              type="text"
              class="form-control"
              placeholder="Buscar pelo Nome"
              v-model="searchForm.fullName"
            />
          </div>
        </div>
        <div class="col-lg-6">
          <div class="input-group col-lg-12">
            <input
              type="text"
              class="form-control"
              placeholder="Buscar por e-mail"
              v-model="searchForm.email"
            />
          </div>
        </div>

        <div class="col-lg-3">
          <div class="input-group col-lg-12">
            <input
              type="text"
              class="form-control"
              placeholder="Buscar pelo CPF"
              v-model="searchForm.cpf"
            />
          </div>
        </div>

        <div class="col-lg-3">
          <div class="input-group col-lg-12">
            <input
              type="text"
              class="form-control"
              placeholder="Buscar por Telefone"
              v-model="searchForm.cellPhone"
            />
          </div>
        </div>
        <div class="col-lg-3">
          <div class="input-group col-lg-12">
            <input
              type="text"
              class="form-control"
              placeholder="Buscar pela Placa"
              v-model="searchForm.licencePlate"
            />
          </div>
        </div>
        <div class="col-lg-3">
          <div class="input-group col-lg-12">
            <button class="btn btn-lg btn-primary">
              <i class="fa fa-search"></i>
              Buscar
            </button>
          </div>
        </div>
      </form>
    </div>
    <spinner v-if="showSpinner" />
    <div class="mail-box">
      <table class="table table-hover table-mail">
        <thead class="table-head">
          <tr>
            <th>Nome</th>
            <th>CPF</th>
            <th>Saldo</th>
            <th></th>
          </tr>
        </thead>

        <tbody class="table-list">
          <tr>
            <td colspan="4" v-if="registerList.originalList === false">
              Efetue a busca utilizando um dos campos do filtro acima.
            </td>
          </tr>
          <tr>
            <td colspan="4" v-if="registerList.originalList.length === 0">
              Não encontramos nenhum registro.
            </td>
          </tr>

          <tr v-for="(user, key) in registerList.originalList" :key="key">
            <td>{{ user.fullName }}</td>
            <td>{{ user.cpf }}</td>
            <td>{{ user.actualBalance | totalToCurrencyBR }}</td>
            <td class="list-command">
              <button type="button" @click="moreInfo(user)" class="info-btn">
                <i class="fa fa-chevron-right"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="btn-group paginatecontent" v-if="form.countPages > 0">
      <button
        class="btn btn-light btn-sm paginatebutton"
        :disabled="hasPageLeft"
        @click="previousPage"
      >
        <i class="fa fa-arrow-left" />
      </button>

      <button
        class="btn btn-light btn-sm paginatebutton"
        :disabled="hasPageRight"
        @click="nextPage"
      >
        <i class="fa fa-arrow-right" />
      </button>
    </div>
  </div>
</template>
<script>
import Spinner from '@/components/Spinner';
export default {
  components: { Spinner },
  props: {
    selectedSchedule: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      showSpinner: false,
      form: {
        pageSkip: 0,
        pageLimit: 15,
        showSettled: true,
        countPages: 0,
      },
      searchForm: {
        fullName: '',
        licencePlate: '',
        cpf: '',
        email: '',
        cellPhone: '',
      },
      continuousTolerance: '',
      selectedUser: '',
      registerList: {
        originalList: false,
        list: [],
      },
      rawList: [],
    };
  },

  mounted() {
    // this.listConsumers();
  },
  watch: {
    'form.pageSkip'() {
      this.listConsumers();
    },
  },
  filters: {
    totalToCurrencyBR(value) {
      return (value / 100).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
      });
    },
  },
  computed: {
    hasPageLeft() {
      return this.form.pageSkip === 1;
    },
    hasPageRight() {
      return this.form.pageSkip >= this.form.countPages;
    },
  },
  methods: {
    async listConsumers() {
      try {
        this.showSpinner = true;
        const consumerList = await this.$store.dispatch(
          'CONSUMER/ListPaginate',
          {
            pageSkip: this.form.pageSkip,
            pageLimit: this.form.pageLimit,
            fullName: this.searchForm.fullName,
            cpf: this.searchForm.cpf,
            licencePlate: this.searchForm.licencePlate,
            email: this.searchForm.email,
            cellPhone: this.searchForm.cellPhone,
          },
        );

        this.form.countPages = Math.ceil(
          Number(consumerList.total) / this.form.pageLimit,
        );

        this.registerList.originalList = consumerList.consumers;
      } catch (error) {
        this.$toasted.error('Não foi Listar ');
      } finally {
        this.showSpinner = false;
      }
    },

    nextPage() {
      if (this.form.pageSkip > this.form.countPages) {
        return;
      }
      this.form.pageSkip += 1;
    },
    previousPage() {
      if (this.form.pageSkip === 1) {
        return;
      }
      this.form.pageSkip -= 1;
    },
    moreInfo(consumer) {
      this.$router.push({
        name: 'ConsumerInfo',
        params: { userToken: consumer.userToken },
      });
    },
  },
};
</script>
